import { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';

import { DEBUG, isVizio } from '../../../../src/helpers/Platform';
import { screenReaderEnabledState, userSettingsState } from '../../../../src/store';

export const VizioSetup = () => {
  const [vizioSetup, setVizioSetup] = useState(false);
  const [, setUserSettings] = useRecoilState(userSettingsState);

  const setCCState = isCCEnabled => {
    setUserSettings(oldState => ({
      ...oldState,
      closedCaptionsEnabled: isCCEnabled,
    }));
  };

  const setScreenReaderEnabledState = useSetRecoilState(screenReaderEnabledState);

  useEffect(() => {
    if (isVizio && window.vizioLoaded && !vizioSetup) {
      // IFA - ID for Advertisement
      window.VIZIO.setAdvertiserIDListener(AdvertiserID => {
        console.log(`AdvertiserID:${AdvertiserID.IFA}`);
        console.log(`AdvertiserIDType:${AdvertiserID.IFA_TYPE}`);
        console.log(`LimitAdTracking:${AdvertiserID.LMT}`);
        window.VIZIO.adID = AdvertiserID;
      });

      window.VIZIO.debugBaseURL = 'http://127.0.0.1:12345/scfs/sctv/main.html';

      window.VIZIO.setContentChangeHandler(contentURL => {
        // Grab the last part of the URL
        console.log(`vizio deeplink: ${contentURL}`);
        if (DEBUG && contentURL === window.VIZIO.debugBaseURL) {
          window.VIZIO.exitApplication();
          window.location.href = window.VIZIO.debugBaseURL;
        }
      });
      setScreenReaderEnabledState(window.VIZIO._ttsEnabled);

      // TTS (Voiceover enabled)
      document.addEventListener(
        'VIZIO_TTS_ENABLED',
        event => {
          setScreenReaderEnabledState(true);
        },
        false,
      );
      document.addEventListener(
        'VIZIO_TTS_DISABLED',
        event => {
          setScreenReaderEnabledState(false);
        },
        false,
      );

      // Closed Captions
      window.VIZIO.setClosedCaptionHandler(isCCEnabled => {
        setCCState(isCCEnabled);
      });

      setVizioSetup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.vizioLoaded]);

  return null;
};
